import Api from "../../utils/config/api";
import { toastr } from "react-redux-toastr";
import {
  RESET_CHANNEL_STATE,
  SET_CHANNEL_DELIVERY_STATUS,
  SET_CHANNEL_HEADERS,
  SET_CHANNEL_LEDGER,
  SET_CHANNEL_MSG_LOGS,
  SET_CHANNEL_OVERVIEW,
  SET_CHANNEL_REFILL_HISTORY,
  SET_TEMPLATES_SEED,
  SET_WA_CUST_HEAD_BILL,
  SET_WA_CUST_HEAD_DRAFT,
  CLEAR_WA_CUST_HEADER_DRAFT,
  CLEAR_WA_CUST_HEADER_BILL,
} from "../types";

export const getChannelRefillHistory =
  (storeId, page, period, start, end) => (dispatch) => {
    return new Promise((resolve, reject) => {
      Api.get(
        `/v1/channels/${storeId}/credits/refill-history?page=${
          page || 1
        }&period=${period}${(start && `&start=${start}`) || ""}${
          (end && `&end=${end}`) || ""
        }`
      )
        .then((res) => {
          dispatch({
            type: SET_CHANNEL_REFILL_HISTORY,
            payload: res?.data?.payload,
          });

          return resolve(res?.data?.payload);
        })
        .catch((err) => {
          err?.response?.status !== 401 &&
            toastr.error(
              "Error",
              err?.response?.data?.message || "Something went wrong!"
            );
          return reject(err);
        });
    });
  };

export const getChannelOverview = (query) => (dispatch) => {
  const storeId = query?.storeId;
  const groupId = query?.groupId;
  const channelKey = query?.channelName;
  const periodKey = query?.period?.key;
  const periodEnd = query?.period?.endDate?.format("YYYY-MM-DD");
  const periodStart = query?.period?.startDate?.format("YYYY-MM-DD");

  const url =
    groupId?.length > 0
      ? `/v1/groups/${groupId}/${channelKey}/${storeId}/overview?period=${periodKey}&start=${periodStart}&end=${periodEnd}`
      : `/v1/channels/${storeId}/${channelKey}/overview?period=${periodKey}&start=${periodStart}&end=${periodEnd}`;

  return new Promise((resolve, reject) => {
    Api.get(url)
      .then((res) => {
        dispatch({
          type: SET_CHANNEL_OVERVIEW,
          payload: res?.data?.payload,
        });

        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );
        return reject(err);
      });
  });
};

export const getChannelDeliveryStatus = (query) => (dispatch) => {
  const storeId = query?.storeId;
  const groupId = query?.groupId;
  const channelKey = query?.channelName;
  const isDontDispatch = query?.isDontDispatch;

  const periodKey = query?.period?.key;
  const periodEnd = query?.period?.endDate?.format("YYYY-MM-DD");
  const periodStart = query?.period?.startDate?.format("YYYY-MM-DD");

  const url =
    groupId?.length > 0
      ? `/v1/groups/${groupId}/${channelKey}/${storeId}/delivery-status-report?period=${periodKey}&start=${periodStart}&end=${periodEnd}`
      : `/v1/channels/${storeId}/${channelKey}/delivery-status-report?period=${periodKey}&start=${periodStart}&end=${periodEnd}`;

  return new Promise((resolve, reject) => {
    Api.get(url)
      .then((res) => {
        if (!isDontDispatch)
          dispatch({
            type: SET_CHANNEL_DELIVERY_STATUS,
            payload: res?.data?.payload,
          });

        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );
        return reject(err);
      });
  });
};

export const getChannelMsgLogs = (query) => (dispatch) => {
  const page = query?.page;
  const type = query?.type;
  const search = query?.search;
  const storeId = query?.storeId;
  const groupId = query?.groupId;
  const isExport = query?.isExport;
  const periodKey = query?.period?.key;
  const channelKey = query?.channelName;
  const entityIdFilter = query?.entityIdFilter;
  const periodEnd = query?.period?.endDate?.toISOString();
  const periodStart = query?.period?.startDate?.toISOString();

  const url = groupId
    ? `/v1/groups/${groupId}/${channelKey}/${storeId}/message-logs/?page=${
        page || 1
      }&period=${periodKey}${periodStart ? `&start=${periodStart}` : ""}${
        periodEnd ? `&end=${periodEnd}` : ""
      }${search ? `&search=${search}` : ""}${type ? `&type=${type}` : ""}${
        entityIdFilter ? `&entity_id_filter=${entityIdFilter}` : ""
      }${isExport ? "&attachment=true" : ""}`
    : `/v1/channels/${storeId}/${channelKey}/message-logs/?page=${
        page || 1
      }&period=${periodKey}${periodStart ? `&start=${periodStart}` : ""}${
        periodEnd ? `&end=${periodEnd}` : ""
      }${search ? `&search=${search}` : ""}${type ? `&type=${type}` : ""}${
        isExport ? "&attachment=true" : ""
      }`;

  return new Promise((resolve, reject) => {
    Api.get(url)
      .then((res) => {
        if (isExport) return resolve(res);

        dispatch({
          type: SET_CHANNEL_MSG_LOGS,
          payload: res?.data?.payload,
        });

        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );
        return reject(err);
      });
  });
};

export const getChannelLedger = (query) => (dispatch) => {
  const page = query?.page || 1;
  const storeId = query?.storeId;
  const groupId = query?.groupId;
  const entityId = groupId || storeId;
  const channelKey = query?.channelName;
  const periodKey = query?.period?.key;
  const isExportQuery = query?.attachment || false;
  const periodEnd = query?.period?.endDate?.format("YYYY-MM-DD");
  const periodStart = query?.period?.startDate?.format("YYYY-MM-DD");

  const url = `/v1/channels/${entityId}/${channelKey}/credits-ledger?page=${page}&period=${periodKey}&start=${periodStart}&end=${periodEnd}${
    isExportQuery ? "&attachment=true" : ""
  }`;

  return new Promise((resolve, reject) => {
    Api.get(url)
      .then((res) => {
        if (isExportQuery) return resolve(res);

        dispatch({
          type: SET_CHANNEL_LEDGER,
          payload: res?.data?.payload,
        });

        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );
        return reject(err);
      });
  });
};

export const getChannelHeader = (entityId) => () => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/channels/channel-headers/${entityId}`)
      .then((res) => {
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );
        return reject(err);
      });
  });
};

export const resetChannelState = () => (dispatch) => {
  dispatch({
    type: RESET_CHANNEL_STATE,
  });
};

// for channel settings

export const getChannelHeadersDetails = (entityId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/channel-header/header-details/${entityId}`)
      .then((res) => {
        dispatch({
          type: SET_CHANNEL_HEADERS,
          payload: res?.data?.payload,
        });
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );
        return reject(err);
      });
  });
};

export const setChannelHeadersDetails = (entityId, data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.post(`/v1/channel-header/header-details/${entityId}`, data)
      .then((res) => {
        dispatch({
          type: SET_CHANNEL_HEADERS,
          payload: res?.data?.payload,
        });
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const getTemplatesSeed = (entityId, data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.post(`/v1/channel-header/templates-seed/${entityId}`, data)
      .then((res) => {
        dispatch({
          type: SET_TEMPLATES_SEED,
          payload: res?.data?.payload,
        });
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );
        return reject(err);
      });
  });
};

export const testDltTemplate = (storeId, data, isWhatsappTemplate) => () => {
  return new Promise((resolve, reject) => {
    Api.post(
      `/v1/channel-header/${
        isWhatsappTemplate ? "whatsapp-" : ""
      }template/test/${storeId}`,
      data
    )
      .then((res) => {
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          err?.response?.data?.errors?.map((errObj) =>
            toastr.error(errObj.msg)
          );
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const clearWaCustomHeaderDraft = () => ({
  type: CLEAR_WA_CUST_HEADER_DRAFT,
});

export const clearWaCustomHeaderBill = () => ({
  type: CLEAR_WA_CUST_HEADER_BILL,
});

export const setWaCustHeadDraft = (data) => (dispatch) => {
  dispatch({
    type: SET_WA_CUST_HEAD_DRAFT,
    payload: Array.isArray(data) ? data[0] : data,
  });
};

export const setWaCustomHeaderCall = (entityId, data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.post(`/v1/channel-header/whatsapp-header-details/${entityId}`, data)
      .then((res) => {
        dispatch(setWaCustHeadDraft(res?.data?.payload));
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          err?.response?.data?.errors?.map((errObj) =>
            toastr.error(errObj.msg)
          );
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const getWaCustomHeaderCall =
  (entityId, phone_number, primary) => (dispatch) => {
    const phoneNumberQuery =
      phone_number?.length > 0 ? `?phone_number=${phone_number}` : "";
    const primaryQueryParam = primary
      ? `${phoneNumberQuery?.length > 0 ? "&" : "?"}primary=${primary}`
      : "";
    const url = `/v1/channel-header/whatsapp-header-details/${entityId}${phoneNumberQuery}${primaryQueryParam}`;

    return new Promise((resolve, reject) => {
      Api.get(url)
        .then((res) => {
          dispatch(setWaCustHeadDraft(res?.data?.payload));
          return resolve(res?.data?.payload);
        })
        .catch((err) => {
          if (err?.response?.status === 422) {
            err?.response?.data?.errors?.map((errObj) =>
              toastr.error(errObj.msg)
            );
            return reject(err?.response?.data?.errors);
          } else {
            toastr.error(
              "Error",
              err?.response?.data?.message || "Something went wrong!"
            );

            return reject(err?.response?.data?.message);
          }
        });
    });
  };

export const getWaTemplateSeed = (entityId, phone_number) => () => {
  return new Promise((resolve, reject) => {
    Api.get(
      `/v1/channel-header/whatsapp-templates-seed/${entityId}${
        phone_number ? `?phone_number=${phone_number}` : ""
      }`
    )
      .then((res) => {
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          err?.response?.data?.errors?.map((errObj) =>
            toastr.error(errObj.msg)
          );
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const sendUpdatedTemplateContentForApproval =
  (storeID, templateID, data, phone_number) => () => {
    return new Promise((resolve, reject) => {
      Api.patch(
        `/v1/channel-header/${templateID}/custom/template/${storeID}/submit?phone_number=${phone_number}`,
        data
      )
        .then((res) => {
          return resolve(res?.data?.payload);
        })
        .catch((err) => {
          err?.response?.data?.errors?.map((errObj) =>
            toastr.error(errObj.msg)
          );

          return reject(err);
        });
    });
  };

export const fetchTemplateStatus = (templateId, key, phone_number) => () => {
  return new Promise((resolve, reject) => {
    Api.get(
      `/v1/channel-header/whatsapp-template/${templateId}/${key}/status?phone_number=${phone_number}`
    )
      .then((res) => {
        const data =
          res?.data?.payload?.response?.UpdatedTemplate ||
          res?.data?.payload?.response;
        return resolve(data);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

export const generateMmLiteLink = (entityId, phone_number) => () => {
  return new Promise((resolve, reject) => {
    Api.get(
      `/v1/channel-header/custom-whatsapp-header/generate-mmlite-link/${entityId}${
        phone_number ? `?phone_number=${phone_number}` : ""
      }`
    )
      .then((res) => {
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          err?.response?.data?.errors?.map((errObj) =>
            toastr.error(errObj.msg)
          );
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const getWaDailySendLimit = (data) => {
  return new Promise((resolve, reject) => {
    Api.post(`/v1/channel-header/whatsapp-header/daily-send-limit`, data)
      .then((res) => resolve(res?.data?.payload))
      .catch((err) => {
        if (err?.response?.status === 422) {
          err?.response?.data?.errors?.map((errObj) =>
            toastr.error(errObj.msg)
          );
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const getWaCustHeadPaymentUrlCall =
  (entityId, couponCode = "", phone_number) =>
  () => {
    return new Promise((resolve, reject) => {
      const url =
        `/v1/channel-header/whatsapp-header-details/one-time-payment/${entityId}` +
        (couponCode ? `?coupon_code=${couponCode}` : "") +
        (couponCode && phone_number ? `&` : "") +
        (!couponCode && phone_number ? `?` : "") +
        (phone_number ? `phone_number=${phone_number}` : "");

      Api.get(url)
        .then((res) => {
          return resolve(res?.data?.payload);
        })
        .catch((err) => {
          if (err?.response?.status === 422) {
            err?.response?.data?.errors?.map((errObj) =>
              toastr.error(errObj.msg)
            );
            return reject(err?.response?.data?.errors);
          } else {
            toastr.error(
              "Error",
              err?.response?.data?.message || "Something went wrong!"
            );

            return reject(err?.response?.data?.message);
          }
        });
    });
  };

export const getWaHeaderPaymentStatus =
  (userId, phone_number) => (dispatch) => {
    return new Promise((resolve, reject) => {
      const data = {
        user_id: userId,
      };
      if (phone_number) {
        data.phone_number = phone_number;
      }
      Api.post(`/v1/channel-header/whatsapp-header/payment-info`, data)
        .then((res) => {
          dispatch({
            type: SET_WA_CUST_HEAD_BILL,
            payload: res?.data?.payload,
          });
          return resolve(res?.data?.payload);
        })
        .catch((err) => {
          if (err?.response?.status === 422) {
            err?.response?.data?.errors?.map((errObj) =>
              toastr.error(errObj.msg)
            );
            return reject(err?.response?.data?.errors);
          } else {
            toastr.error(
              "Error",
              err?.response?.data?.message || "Something went wrong!"
            );

            return reject(err?.response?.data?.message);
          }
        });
    });
  };

export const getRedemptionOtpChannels = (entityId) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/stores/${entityId}/redemption-otp/channels`)
      .then((res) => resolve(res?.data?.payload))
      .catch((err) => {
        if (err?.response?.status === 422) {
          err?.response?.data?.errors?.map((errObj) =>
            toastr.error(errObj.msg)
          );
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const updateRedemptionOtpChannels = (storeId, data) => {
  return new Promise((resolve, reject) => {
    Api.patch(`/v1/stores/${storeId}/redemption-otp/channels`, data)
      .then((res) => resolve(res?.data?.payload))
      .catch((err) => {
        if (err?.response?.status === 422) {
          err?.response?.data?.errors?.map((errObj) =>
            toastr.error(errObj.msg)
          );
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};
